import React from "react";
import { Box, Skeleton } from "@mui/material";

const BookingHeaderPanelSkeleton: React.FC = () => (
    <Box sx={{
        display: "flex",
        flexWrap: { xs: "wrap", md: "nowrap" },
        alignItems: "flex-start",
        borderRadius: 1,
        bgcolor: "white",
        border: "2px solid #eee",
        p: "12px 16px",
        gap: 1,
        animation: "fadeInUp 400ms cubic-bezier(0.4, 0, 0.2, 1) backwards",
        "@keyframes fadeInUp": {
            from: { opacity: 0, transform: "translateY(12px)" },
            to: { opacity: 1, transform: "translateY(0)" },
        },
    }}>
        {/* Product lozenges */}
        <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", justifyContent: "flex-start", gap: 1, flex: "1 1 0%", minWidth: 0 }}>
            <Box sx={{ width: "100%" }}>
                <Skeleton variant="text" width={140} sx={{ fontSize: "0.95rem", lineHeight: 1.5 }} animation="wave" />
            </Box>
            <Skeleton variant="rounded" width={100} height={28} sx={{ borderRadius: 2 }} animation="wave" />
            <Skeleton variant="rounded" width={120} height={28} sx={{ borderRadius: 2 }} animation="wave" />
        </Box>
        {/* Badgees */}
        <Box sx={{
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: { xs: "flex-start", md: "flex-end" },
            gap: 0.75,
            ml: { xs: 0, md: "auto" },
            pl: { xs: 0, md: 1.5 },
            mt: { xs: 1, md: 0 },
            flex: { xs: "1 0 100%", md: "0 0 auto" },
        }}>
            <Skeleton variant="rounded" width={80} height={26} sx={{ borderRadius: 2 }} animation="wave" />
        </Box>
    </Box>
);

export default BookingHeaderPanelSkeleton;
